import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from '../components/App/App';
import store from './initializeReduxStore';

const domNode = document.getElementById('app');
const root = ReactDOM.createRoot(domNode);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
